import React from 'react';
import PropTypes from 'prop-types';
/* helpers */
import { sortItemsByPropertyName } from '../../utils/info-helper';
/* Components */
import TableHeadCell from '../../components/table-head-cell/table-head-cell';
import EmptyContent from '../../components/empty-content/empty-content';
import Menu, { MenuItem } from '../../components/menu/menu';
import ScrollArea from '../../components/scroll-area/scroll-area';
/* styles */
import './system-users.scss';

const tableColumns = [
    { title: 'Email', prop: 'email', sortable: true, className: 'text-ellipsis', showTitle: true },
    { title: 'Enabled User', prop: 'isActive', width: 10, sortable: true, type: 'boolean' },
    { title: 'Allow Local Login', prop: 'localLoginEnabled', width: 12, sortable: true, type: 'boolean' }
];

class SystemUsersPage extends React.PureComponent {
    state = {
        sortedUsers: [...this.props.users],
        sortProp: '',
        sortOrder: 'ASC'
    };

    setSortProp = (prop) => {
        let sortProp = this.state.sortProp;
        let sortOrder = this.state.sortOrder;
        if (prop === this.state.sortProp) {
            sortOrder = this.state.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            sortProp = prop;
            sortOrder = 'ASC';
        }
        const sortedUsers = this.props.users.slice().sort(sortItemsByPropertyName(sortProp, sortOrder === 'ASC'));
        this.setState({ sortProp, sortOrder, sortedUsers });
    };

    renderCellValue = (col, value) => {
        if (!value[col.prop]) {
            return '-';
        }
        if (col.type === 'boolean') {
            return (
                <span className={`sten-badge ${value[col.prop] ? 'sten-badge--success' : 'sten-badge--danger'}`}>
                    {value[col.prop] ? 'Yes' : 'No'}
                </span>
            );
        }
        return value[col.prop];
    };

    renderTitle = (col, value) => value[col.prop] || '-';

    renderMenu = (scope) => (
        <Menu menuRight>
            <MenuItem linkTo={`/scopes/edit/?name=${scope.scopeName}`} icon="icon-edit">
                Edit
            </MenuItem>
            <MenuItem onClick={this.handleDelete.bind(this, scope.scopeId)} icon="icon-delete">
                Delete
            </MenuItem>
        </Menu>
    );

    render() {
        const { sortProp, sortOrder, sortedUsers } = this.state;
        return (
            <div className="sten-content sten-system-users-page">
                <div className="sten-content__header">
                    <h1 className="sten-content__title text-uppercase">System users</h1>
                </div>
                <ScrollArea className="sten-content__body">
                    <section className="sten-content__section">
                        <div className="sten-panel col-lg-12 col-md-18 col-xs-24">
                            <div className="sten-panel__header flex">
                                <div className="flex-grow">
                                    <div className="flex-row flex-center">
                                        <div className="flex-grow">
                                            <h3 className="sten-panel__title">System users</h3>
                                        </div>
                                        <div className="flex-shrink">
                                            <a href="/systemUsers/create">
                                                <span className="btn__icon icon icon-plus" />
                                                Add System User
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="sten-panel__body">
                                {sortedUsers.length > 0 ? (
                                    <table className="sten-table sten-table--sm">
                                        <thead>
                                            <tr>
                                                {tableColumns.map((col, index) => (
                                                    <TableHeadCell
                                                        style={{ width: `${col.width}rem` }}
                                                        sortOrder={sortProp === col.prop ? sortOrder : ''}
                                                        sortable={col.sortable}
                                                        /* eslint-disable-next-line react/no-array-index-key */
                                                        key={index}
                                                        onClick={this.setSortProp.bind(this, col.prop)}
                                                    >
                                                        {col.title}
                                                    </TableHeadCell>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sortedUsers.map((user) => (
                                                /* eslint-disable-next-line react/no-array-index-key */
                                                <tr key={user.subjectId}>
                                                    {tableColumns.map((col, index) => (
                                                        <td
                                                            /* eslint-disable-next-line react/no-array-index-key */
                                                            key={index}
                                                            className={col.className}
                                                            title={col.showTitle ? this.renderTitle(col, user) : ''}
                                                        >
                                                            {this.renderCellValue(col, user)}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <EmptyContent />
                                )}
                            </div>
                        </div>
                    </section>
                </ScrollArea>
            </div>
        );
    }
}

SystemUsersPage.propTypes = {
    users: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default SystemUsersPage;
